import { VehicleStatusCode } from "../../api/types/VehicleStatusCode";
export const IGNITION_STATUS_CODES: VehicleStatusCode[] = [
  VehicleStatusCode.STATUS_IGNITION_ON,
  VehicleStatusCode.STATUS_IGNITION_OFF,
];

// color names can be found at:
// https://colors.artyclick.com/color-name-finder/

export const TRIP_COLORS = [
  "#0E88FF", // Bleu de France
  "#FFDD4A", // Mustard
  "#DD6BAD", // Sky Magenta
  "#FE9000", // Princeton Orange
  "#006600", // Malachite (#04E762) - changed to dark green
  "#800080", // Purple
  "#FF4500", // Tangelo (bright red)
  "#2BB0B0", // Verdigris (darker cyan)
  "#892557", // Murrey (darker magenta)
  "#8A2BE2", // Blue Violet
  "#FF1493", // Deep Pink
  "#00FF7F", // Spring Green
  "#00BFFF", // Deep Sky Blue
  "#FF6347", // Tomato
  "#009006", // India green
  "#582B11", // Seal Brown
  "#85FF9E", // Light green
  "#FFB6C1", // Cherry blossom pink
  "#7BC950", // Mantis
  "#FFA07A", // Atomic Tangerine
  "#FF69B4", // Hot Pink
  "#2EC4B6", // Light Sea Green
  "#A6808C", // Mountbatten Pink
  "#AF125A", // Amaranth Purple
  "#CCB7AE", // Pale Dogwood
  "#FFD700", // Bright Gold / Rubber Ducky Yellow

  "#51A3A3", // Hippie Blue
  "#75485E", // Dirty Purple
  "#CB904D", // Persian Orange
  "#DFCC74", // Sand
  "#92CEA3", // Pale Teal
  "#FFD059", // Light Mustard
  "#FF5959", // Sunset Orange
  "#C3E991", // Green Thumb
  "#FF9B71", // Atomic Tangerine
  "#C6E2E9", // Jagged Ice
];
